import styled, { css } from 'styled-components';
export const GenericErrorMessageText = styled.span `
  text-align: center;
  overflow: hidden;
  width: 100%;
  ${({ theme }) => theme.common.Ellipsis};
  ${({ size, direction }) => {
    if (direction === 'column') {
        switch (size) {
            case 'Small':
                return css `
            padding: 0px 20px 15px;
          `;
            case 'Medium':
                return css `
            padding: 0px 25px 15px;
          `;
            case 'Large':
            default:
                return css `
            padding: 0px 25px 15px;
          `;
        }
    }
    else if (direction === 'row') {
        switch (size) {
            case 'Small':
                return css ``;
            case 'Medium':
                return css ``;
            case 'Large':
            default:
                return css `
            text-align: left;
            position: absolute;
            top: 50%;
            left: 50%;
            padding-left: 40px;
            transform: translate(-50%, -50%);
          `;
        }
    }
    return '';
}}

  ${({ direction }) => direction === 'column' &&
    css `
      justify-content: center;
      text-align: center;
    `}
`;
export const GenericErrorMessageWrapper = styled.div `
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  border-radius: 8px;

  ${({ theme }) => theme.fonts.PoppinsText};

  ${({ isStyled }) => isStyled &&
    css `
      background-color: ${({ theme }) => theme.colors.OtherDraftHover};
      color: ${({ theme }) => theme.colors.TextHighlight1};
      border: 1px solid ${({ theme }) => theme.colors.TextHighlight2};
    `}
  ${({ direction }) => direction === 'column' &&
    css `
      justify-content: center;
    `}
  ${({ theme }) => theme.common.Ellipsis};
  ${({ size, direction }) => {
    if (direction === 'row') {
        switch (size) {
            case 'Small':
                return css `
            padding: 10px 14px 10px 10px;
            font-size: 12px;
            line-height: 16px;
          `;
            case 'Medium':
                return css `
            padding: 10px 20px 10px 10px;
            font-size: 14px;
            line-height: 22px;
          `;
            case 'Large':
            default:
                return css `
            padding: 10px 20px 10px 10px;
            font-size: 16px;
            line-height: 24px;
          `;
        }
    }
    else if (direction === 'column') {
        switch (size) {
            case 'Small':
                return css `
            padding: 10px 14px 10px 10px;
            font-size: 12px;
            line-height: 20px;
          `;
            case 'Medium':
                return css `
            padding: 10px 14px 10px 10px;
            font-size: 14px;
            line-height: 22px;
          `;
            case 'Large':
            default:
                return css `
            padding: 10px 14px 10px 10px;
            font-size: 16px;
            line-height: 24px;
          `;
        }
    }
    return '';
}};

  ${({ height }) => height &&
    css `
      height: ${height};
      max-height: ${height};
      min-height: ${height};
    `};

  ${({ width }) => width &&
    css `
      width: ${width};
      max-width: ${width};
      min-width: ${width};
    `};
  ${({ direction }) => direction &&
    css `
      flex-direction: ${direction};
    `};
`;
//# sourceMappingURL=GenericErrorMessage.styled.js.map